<template>
  <Dialog v-model:visible="isTwoFactorAuthenticationProcess" :style="{width: '35vw'}" position="center"
          :showHeader="showheader" @update:visible="process2FADestroy">
    <div v-if="isTwoFactorAuthenticationProcess"
         class="section--column--center--full section--center__separate1 process2fa__wrapper__security">
      <!--style="width: 500px; height: 500px; border-style: solid">-->
      <div class="flex__separate05">
        <span class="title">{{ $t('TwoFactorAuth.TwoFactorAuthentication').toUpperCase() }}</span>
      </div>
      <infoauthapp2fa v-if="isTwoFactorAuthenticationProcessInfo2FA"></infoauthapp2fa>
      <authenticatorapp2fa v-if="isTwoFactorAuthenticationProcessAuthApp"></authenticatorapp2fa>
      <setup2fa v-if="isTwoFactorAuthenticationProcessEnableToSetup"></setup2fa>
      <validate2fa v-if="isTwoFactorAuthenticationProcessEnableToValidate"></validate2fa>
    </div>
  </Dialog>

</template>

<script lang="ts">
import {computed, defineComponent, ref, watch} from "vue";
import {AuthenticatorValidationStatus} from "@/types/autenticationresult";
import Infoauthapp2fa from "@/components/TwoFactorAuth/infoauthapp2fa.vue";
import {useStore} from "vuex";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import Authenticatorapp2fa from "@/components/TwoFactorAuth/authenticatorapp2fa.vue";
import Setup2fa from "@/components/TwoFactorAuth/setup2fa.vue";
import Validate2fa from "@/components/TwoFactorAuth/validate2fa.vue";
import {RouterPaths} from "@/types/RouterData";
import {useRoute, useRouter} from "vue-router";
import AuthenticationserviceService from "@/services/authenticationservice.service";

export default defineComponent({
  components: {
    Validate2fa,
    Setup2fa,
    Authenticatorapp2fa,
    Infoauthapp2fa
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogHeader = computed(() => {
      return 'prueba';
    });

    const currentRoute = computed(() => {
      return route.name;
    });

    const isLoginRoute = computed(() => {
      return currentRoute.value === RouterPaths.Login;
    });

    const showheader = computed(() => {
      // return !isLoginRoute.value;
      return false;
    });

    const twofactorauthprocess = computed(() => {
      return store.getters.getTwoFactorAuthStep;
    });

    const isTwoFactorAuthenticationProcess = computed(() => {
      return twofactorauthprocess.value !== AuthenticatorValidationStatus.None;
    });

    const isTwoFactorAuthenticationProcessNone = computed(() => {
      return twofactorauthprocess.value === AuthenticatorValidationStatus.None;
    });

    const isTwoFactorAuthenticationProcessInfo2FA = computed(() => {
      return twofactorauthprocess.value === AuthenticatorValidationStatus.Info2FA;
    });

    const isTwoFactorAuthenticationProcessAuthApp = computed(() => {
      return twofactorauthprocess.value === AuthenticatorValidationStatus.AuthApp;
    });

    const isTwoFactorAuthenticationProcessEnableToSetup = computed(() => {
      return twofactorauthprocess.value === AuthenticatorValidationStatus.EnabledToSetup;
    });

    const isTwoFactorAuthenticationProcessEnableToValidate = computed(() => {
      return twofactorauthprocess.value === AuthenticatorValidationStatus.EnabledToValidate;
    });

    watch(twofactorauthprocess, () => {
      // console.log('twofactorauthprocess: ' + twofactorauthprocess.value);
      if (twofactorauthprocess.value && twofactorauthprocess.value === AuthenticatorValidationStatus.Validated) {
        // console.log('ha terminado la validación. resetear estado 2FA')
        store.commit("resetTwoFactorAuth");
      }
    });

    const isSecurityUrl = computed(() => {
      return currentRoute.value === RouterPaths.UserSecurity;
    });

    const process2FADestroy = () => {
      // console.log('process2FADestroy. this.twoFactorAuthenticationProcessStatus: '
      //     + JSON.stringify(twofactorauthprocess.value));
      if (twofactorauthprocess.value !== AuthenticatorValidationStatus.Validated && isSecurityUrl.value) {
        TwoFactorAuthenticationAPPService.setAuthenticatorConfiguration(false, store);
        store.commit("setCancelTwoFactorProcess", true);
        // this.securityEnabled = false;
        // this.AuthAppEnabled = false;
      }
    }

    return {
      isTwoFactorAuthenticationProcessNone,
      isTwoFactorAuthenticationProcess,
      isTwoFactorAuthenticationProcessInfo2FA,
      isTwoFactorAuthenticationProcessAuthApp,
      isTwoFactorAuthenticationProcessEnableToSetup,
      isTwoFactorAuthenticationProcessEnableToValidate,
      twofactorauthprocess,
      DialogHeader,
      showheader,
      process2FADestroy
    }
  }
});

</script>


<style scoped>
.title {
  text-decoration: underline;
  text-decoration-color: var(--ingeteam-color);
}
</style>
